import { Select, styled } from "@mui/material";

const SelectStyled = styled(Select)(() => ({
  color: "#333333",
  borderColor: "#6C6D70",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6C6D70",
  },
  "& .MuiSvgIcon-root": {
    color: "#E04B8D",
  },
}));

export { SelectStyled };
